
const REM_UNIT = 200;

export function addStyle(newStyle, id: string) {
  if (!newStyle || !id) return;
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('style');
    el.setAttribute('type', 'text/css');
    el.id = id;
    document.getElementsByTagName('head')[0].appendChild(el);
  }
  el.appendChild(document.createTextNode(newStyle));
}

export function parseRem(num: number) {
  return `${num / REM_UNIT}rem`;
}
